import { graphql } from '@teachino/shared-infrastructure';
import { courseBadgeFragment } from './course-badge.fragment';

export const myCoursesQuery = graphql(
  `
    query MyCourses {
      myCourses(
        coursesQueryFilter: { status: OPEN, usage: REGULAR, access: WRITE }
      ) {
        ...CourseBadge
      }
    }
  `,
  [courseBadgeFragment],
);
